import { useEffect, useState } from "react";
import API from "../../../services/api";

function AdminPopupStats() {

  const [popups, setPopups] =
    useState([]);

  useEffect(() => {

    API.get("/popups")
      .then(res => {

        setPopups(
          res.data
        );

      });

  }, []);

  return (

    <div>

      <h1>
        Statistiques Popups
      </h1>

      <table>

        <thead>

          <tr>

            <th>Titre</th>

            <th>Vues</th>

            <th>Clics</th>

            <th>Taux</th>

          </tr>

        </thead>

        <tbody>

          {popups.map(popup => {

            const rate =
              popup.views > 0

              ? (
                  popup.clicks /
                  popup.views *
                  100
                ).toFixed(1)

              : 0;

            return (

              <tr
                key={popup._id}
              >

                <td>
                  {popup.title}
                </td>

                <td>
                  {popup.views}
                </td>

                <td>
                  {popup.clicks}
                </td>

                <td>
                  {rate}%
                </td>

              </tr>

            );

          })}

        </tbody>

      </table>

    </div>

  );

}

export default AdminPopupStats;